module.exports = __webpack_public_path__ + "img/1560942923.7c37dd0e.jpg";